import { useState } from "react";

import { EyeIcon, EyeOffIcon } from "../lib/icons";
import { Input, type InputProps } from "./input";

export interface PasswordInputProps extends Omit<InputProps, "type" | "trailing"> {}

/**
 * Champ mot de passe avec bascule d'affichage.
 *
 * Le bouton « révéler » n'est pas un confort : masquer la saisie sans permettre
 * de la relire est l'une des principales causes d'échec de connexion sur mobile.
 * Le NIST le recommande explicitement (SP 800-63B, §5.1.1.2).
 *
 * Le bouton est délibérément hors du flux de tabulation (`tabIndex={-1}`) : au
 * clavier on passe du champ au bouton de validation, pas par un contrôle
 * d'affichage. Il reste atteignable à la souris et aux technologies d'assistance.
 */
export function PasswordInput({ ...props }: PasswordInputProps) {
  const [visible, setVisible] = useState(false);

  return (
    <Input
      type={visible ? "text" : "password"}
      autoComplete="current-password"
      trailing={
        <button
          type="button"
          tabIndex={-1}
          onClick={() => setVisible((current) => !current)}
          aria-label={visible ? "Masquer le mot de passe" : "Afficher le mot de passe"}
          aria-pressed={visible}
          className="rounded-sm text-fg-muted transition-colors duration-fast hover:text-fg focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
        >
          {visible ? <EyeOffIcon className="size-4" /> : <EyeIcon className="size-4" />}
        </button>
      }
      {...props}
    />
  );
}
